let currentFilterValues = null

export function getVacanciesFilterValues() {
  return currentFilterValues || { selectedVacancyCategory: "all", selectedVacancyCity: "all" }
}

export function computeFilterValues() {
  // Compute filter values based on existing vacancies in dom and return them
  const vacanciesListEl = document.querySelector(".js_vacancies_list")

  if (!vacanciesListEl) return { vacancyCategories: [], vacancyCities: [] }

  const vacancies = vacanciesListEl.querySelectorAll(".js_vacancy")

  const vacancyCategories = new Map()
  const vacancyCities = new Map()

  vacancies.forEach((vacancy) => {
    const { category, city } = vacancy.dataset
    const categoryName = vacancy.querySelector(".js_vc_category").textContent
    const cityName = vacancy.querySelector(".js_vc_city").textContent

    if (!vacancyCategories.has(category)) {
      vacancyCategories.set(category, { category, title: categoryName })
    }

    if (!vacancyCities.has(city)) {
      vacancyCities.set(city, { city, title: cityName })
    }
  })

  return {
    vacancyCategories: Array.from(vacancyCategories.values()),
    vacancyCities: Array.from(vacancyCities.values()),
  }
}

export function filterVacancies({ selectedVacancyCategory, selectedVacancyCity }) {
    const vacanciesSection = document.querySelector(".js_vacancies_section")
    const vacanciesListEl = vacanciesSection.querySelector(".js_vacancies_list")
    if (!vacanciesListEl) return
    const vacancies = vacanciesListEl.querySelectorAll(".js_vacancy")
    
    vacancies.forEach((vacancy) => {
      const { category, city } = vacancy.dataset
  
      if (selectedVacancyCategory !== "all" && selectedVacancyCategory !== category) {
        vacancy.setAttribute("hidden", true);
      } else if (selectedVacancyCity !== "all" && selectedVacancyCity !== city) {
        vacancy.setAttribute("hidden", true);
      } else {
        vacancy.removeAttribute("hidden");
      }
    })
    currentFilterValues = { selectedVacancyCategory, selectedVacancyCity }

    // Set active class for js_mobile_vacancies_filter_opener button if filter is applied and remove it if filter is reset
    const filterOpener = vacanciesSection.querySelector(".js_mobile_vacancies_filter_opener")
    if (selectedVacancyCategory !== "all" || selectedVacancyCity !== "all") {
      filterOpener.classList.add("active")
    } else {
      filterOpener.classList.remove("active")
    }

    // Show js_vacancies_not_found if no vacancies found
    const vacanciesNotFound = vacanciesSection.querySelector(".js_vacancies_not_found")

    if (vacanciesNotFound) {
      const hiddenVacancies = vacanciesListEl.querySelectorAll(".js_vacancy[hidden]")
      if (hiddenVacancies.length === vacancies.length) {
        vacanciesNotFound.removeAttribute("hidden")
      } else {
        vacanciesNotFound.setAttribute("hidden", true)
      }
    }
  }
  